import React from 'react';
// eslint-disable-next-line jira/restricted/styled-components, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { ThemeProvider } from 'styled-components';
import { ProjectContextProvider } from '@atlassian/jira-providers-project-context';
import { ServiceDeskAnalyticsContext } from '@atlassian/jira-servicedesk-analytics/src/ui/servicedesk-analytics-context/index.tsx';
import { ProjectSettingsController } from '@atlassian/jira-spa-apps-project-settings-common/src/components/routing-filter';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { withRouter, type RouteContext } from '@atlassian/react-resource-router';
import { ServiceDeskLanguageTranslations } from './view';

type Props = RouteContext;

export function ServiceDeskLanguageTranslationsPage(props: Props) {
	const { projectKey } = props.match.params;
	const { location } = props;
	return (
		<ProjectSettingsController projectKey={projectKey}>
			<TenantContextSubscriber>
				{({ tenantContext }) => (
					<ProjectContextProvider>
						{(projectContext) => (
							<ThemeProvider theme={{}}>
								<ServiceDeskAnalyticsContext>
									<ServiceDeskLanguageTranslations
										tenantContext={tenantContext}
										projectContext={projectContext.data}
										currentPath={location.pathname}
									/>
								</ServiceDeskAnalyticsContext>
							</ThemeProvider>
						)}
					</ProjectContextProvider>
				)}
			</TenantContextSubscriber>
		</ProjectSettingsController>
	);
}

export default withRouter(ServiceDeskLanguageTranslationsPage);
